import { render, staticRenderFns } from "./InfoCumplimientos.vue?vue&type=template&id=86280f9e&"
import script from "./InfoCumplimientos.vue?vue&type=script&lang=ts&"
export * from "./InfoCumplimientos.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCumplimientos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('86280f9e', component.options)
    } else {
      api.reload('86280f9e', component.options)
    }
    module.hot.accept("./InfoCumplimientos.vue?vue&type=template&id=86280f9e&", function () {
      api.rerender('86280f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadorBHP/InfoCumplimientos.vue"
export default component.exports